(
function(){
  var s=document.currentScript&&document.currentScript.src||"";
  var u=s.split("?")[0];
  var f=(u.substring(0,u.lastIndexOf("/"))+"/");
  var r=window.HQP_ASSET_URL||f;
  var b=(function(x){var y=String(x||'');if(y.indexOf('?')>=0)y=y.split('?')[0];if(y.endsWith('/'))return y;return y.substring(0,y.lastIndexOf('/')+1);})(r);
  function qs(k){try{var p=new URLSearchParams(location.search);return p.get(k)||"";}catch(e){return""}}
  function normModel(x){return String(x||'').toUpperCase().replace(/-/g,'')}
  function modelVariants(x){var up=String(x||'').toUpperCase();var no=up.replace(/-/g,'');var out=[up,no];var uniq=[];for(var i=0;i<out.length;i++){var v=out[i];if(!v)continue;if(uniq.indexOf(v)===-1)uniq.push(v)}return uniq}
  function encodeModel(x){try{return encodeURIComponent(String(x||''))}catch(e){return String(x||'')}}
  function mapPick(map, model){var vars=modelVariants(model);for(var i=0;i<vars.length;i++){var k=vars[i];if(map&&Object.prototype.hasOwnProperty.call(map,k))return map[k]}return null}
  function fetchJson(urls,cb){(function i(j){if(j>=urls.length){cb(null,null);return}fetch(urls[j],{cache:'no-cache'}).then(function(r){if(!r.ok){i(j+1);return}return r.json()}).then(function(d){cb(d,urls[j])}).catch(function(){i(j+1)})})(0)}
  function getData(cb){
    if(window.HQP_EMBED_DB){console.log('Using embedded DB');cb(window.HQP_EMBED_DB);return}
    fetchJson([b+'js-products_v3.json','assets/products_v3.json','/pages/assets/products_v3.json'],cb)
  }
  function on(el,ev,fn){if(el){el.addEventListener(ev,fn)}}
  function initLazyImages(){
    try{
      var imgs=document.querySelectorAll('img[loading="lazy"]');
      Array.prototype.forEach.call(imgs,function(img){
        try{
          if(img.classList&&!img.classList.contains('hqp-img')) img.classList.add('hqp-img');
          if(img.complete&&img.naturalWidth>0){
            if(img.classList) img.classList.add('is-loaded');
            return;
          }
          img.addEventListener('load',function(){try{if(img.classList) img.classList.add('is-loaded')}catch(e){}},{once:true});
          img.addEventListener('error',function(){try{if(img.classList) img.classList.add('is-error')}catch(e){}},{once:true});
        }catch(e){}
      });
    }catch(e){}
  }
  function mobileMenu(){var btn=document.querySelector('.mobile-menu-button');var m=document.querySelector('.mobile-menu');on(btn,'click',function(){if(m){m.classList.toggle('hidden')}})}
  function organize(arr){var cats={};(arr||[]).forEach(function(p){var c=p.category||'other';(cats[c]||(cats[c]=[])).push(p)});return cats}
  function sum(names,cats){return (names||[]).reduce(function(acc,n){return acc+((cats[n]||[]).length)},0)}
  function runProducts(){var kc=document.getElementById('kettle-count');var cc=document.getElementById('coffee-count');var oc=document.getElementById('cooking-count');if(!kc||!cc||!oc)return;var info=document.getElementById('total-products-info');getData(function(data){ if(HQP.Utils.isDebugEnabled()) console.log('[HQP] runProductCatalog data received:', data ? (data.products ? data.products.length : 'no products') : 'no data');if(!data){kc.textContent='--';cc.textContent='--';oc.textContent='--';return}var products=Array.isArray(data.products)?data.products:[];var cats=organize(products);kc.textContent=sum(['Electric Kettle','Stovetop Gooseneck kettle','Glass kettle','Stainless steel kettle','Ceramic kettle','Gooseneck Kettle'],cats);cc.textContent=sum(['Coffee Maker','Espresso Machine','Milk Frother','Coffee Grinder','Drip Coffee Maker'],cats);oc.textContent=sum(['Cooking Machine','Airfyer oven','Steam Oven','Oven','Air Fryer','Air fryer oven'],cats);if(info){info.innerHTML='<i class="fa fa-cube mr-2"></i><span>'+products.length+' Products</span>'}})}
  function text(el,t){if(el){el.textContent=t}}
  function runProductDetail(){
    var box=document.getElementById('product-info');
    if(!box)return;
    var q=(qs('model')||'');
    var qn=normModel(q);
    
    getData(function(data){ if(HQP.Utils.isDebugEnabled()) console.log('[HQP] runProductCatalog data received:', data ? (data.products ? data.products.length : 'no products') : 'no data');
      console.log('Products JSON loaded:', data ? 'Success' : 'Failed');
      var arr=Array.isArray(data&&data.products)?data.products:[];
      console.log('Total products in JSON:', arr.length);
      
      var prod=arr.find(function(p){
        var m = normModel(p.model||p.Model||'');
        return m === qn;
      });

      prod = prod || {}; // Safety
      
      var displayTitle = prod.title || prod.name;
      if(!displayTitle && prod.model) displayTitle = (prod.category || 'Product') + ' - ' + prod.model;
      
      text(document.getElementById('prod-title'), displayTitle || 'Product Not Found');
      text(document.getElementById('prod-model'),prod.model||'');
      
      var img = document.getElementById('prod-image');
      if(img){
        var local = localCandidate(prod.model);
        fetchJson([b+'js-image_product_map_files.json','assets/image_product_map_files.json','/pages/assets/image_product_map_files.json'],function(map){
          var mappedEntry = mapPick(map, prod.model||prod.Model||'');
          var tryFiles = Array.isArray(mappedEntry) ? mappedEntry[0] : null;
          img.src = HQP.Utils.normalizeImagePath(local || tryFiles || (prod.images && prod.images[0]) || ('assets/images/01-index/factory-001.jpg'));
          img.onerror = function(){ if(tryFiles){ img.src = HQP.Utils.normalizeImagePath(tryFiles); } };
        })
      }

      var ul=document.getElementById('prod-features');
      if(ul){
        ul.innerHTML='';
        var feats = prod.features || [];
        if(typeof feats === 'string') feats = [feats]; // Handle string case
        feats.slice(0,6).forEach(function(f){
          var li=document.createElement('li');
          li.textContent=f;
          ul.appendChild(li)
        });
      }
    })
  }
  function runRfq(){var form=document.getElementById('rfq-form');if(!form)return;var steps=[1,2,3,4];var cur=1;function show(n){steps.forEach(function(i){var el=document.getElementById('rfq-step-'+i);if(el){el.classList.toggle('hidden',i!==n)}});var lab=document.getElementById('rfq-step-label');if(lab)lab.textContent=String(n);cur=n}function next(){if(cur<4)show(cur+1)}function prev(){if(cur>1)show(cur-1)}var nx=document.getElementById('rfq-next');var pv=document.getElementById('rfq-prev');on(nx,'click',next);on(pv,'click',prev);var catOther=document.getElementById('rfq-cat-other');Array.prototype.forEach.call(document.querySelectorAll('.rfq-cat'),function(cb){on(cb,'change',function(){if(this.value==='Other'){catOther.classList.toggle('hidden',!this.checked)}})});var subEmail=document.getElementById('rfq-submit-email');var subWa=document.getElementById('rfq-submit-wa');var copyBtn=document.getElementById('rfq-copy');function summary(){var companyType=document.getElementById('rfq-company-type')?.value||'';var region=document.getElementById('rfq-region')?.value||'';var contact=document.getElementById('rfq-contact')?.value||'';var company=document.getElementById('rfq-company')?.value||'';var categories=[];Array.prototype.forEach.call(document.querySelectorAll('.rfq-cat'),function(cb){if(cb.checked)categories.push(cb.value)});if(catOther && !catOther.classList.contains('hidden') && catOther.value)categories.push(catOther.value);var annual=document.getElementById('rfq-annual')?.value||'';var moq=document.getElementById('rfq-moq')?.value||'';var lead=document.getElementById('rfq-lead')?.value||'';var certs=[];Array.prototype.forEach.call(document.querySelectorAll('.rfq-cert'),function(cb){if(cb.checked)certs.push(cb.value)});var pack=document.getElementById('rfq-pack')?.value||'';var proto=document.getElementById('rfq-proto')?.value||'';var sample=document.getElementById('rfq-sample')?.value||'';var msg=document.getElementById('rfq-msg')?.value||'';return [
      'Company Type: '+companyType,
      'Region: '+region,
      'Contact: '+contact,
      'Company: '+company,
      'Categories: '+categories.join(', '),
      'Annual: '+annual,
      'Target MOQ: '+moq,
      'Lead Time: '+lead,
      'Compliance: '+certs.join(', '),
      'Packaging: '+pack,
      'Prototype: '+proto,
      'Sample Time: '+sample,
      'Message: '+msg
    ].join('\n')}
  on(copyBtn,'click',function(){var txt=summary();try{navigator.clipboard.writeText(txt)}catch(e){}});
  on(subEmail,'click',function(){var txt=encodeURIComponent(summary());location.href='mailto:admin@HQPmade.com?subject=RFQ&body='+txt});
  on(subWa,'click',function(e){e.preventDefault();var txt=encodeURIComponent(summary());var url='https://wa.me/+8617684299858?text='+txt;subWa.setAttribute('href',url);location.href=url});
  show(1)}
  function runFooterSocial(){
    var icons = document.querySelectorAll('footer .footer-social-icon[data-href]');
    Array.prototype.forEach.call(icons, function(el){
        var url = el.getAttribute('data-href');
        function openLink(){
            if (!url) return;
            if (url.indexOf('mailto:') === 0) {
                window.location.href = url;
            } else {
                window.open(url, '_blank', 'noopener');
            }
        }
        el.addEventListener('click', function(e){ e.preventDefault(); openLink(); });
        el.addEventListener('keydown', function(e){
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLink(); }
        });
    });
  }
  document.addEventListener('DOMContentLoaded',function(){ var __h=(function(){try{var p=location.pathname||'';var m=p.match(/\/pages\/([^\/?#]+)/i);return m?m[1].toLowerCase():''}catch(e){return''}})(); if(['electric-kettles','coffee-makers','cooking-machines','air-fryers','espresso-machines','other-products'].indexOf(__h)>=0 && !document.getElementById('category-product-grid')) runCategory(); mobileMenu();runProducts();runProductDetail();runFooterSocial();initLazyImages()})
  document.addEventListener('DOMContentLoaded',function(){ var __h=(function(){try{var p=location.pathname||'';var m=p.match(/\/pages\/([^\/?#]+)/i);return m?m[1].toLowerCase():''}catch(e){return''}})(); if(['electric-kettles','coffee-makers','cooking-machines','air-fryers','espresso-machines','other-products'].indexOf(__h)>=0 && !document.getElementById('category-product-grid')) runCategory(); runRfq()})
  function normHandle(){try{var p=location.pathname||'';var m=p.match(/\/pages\/([^\/?#]+)/i);return m?m[1].toLowerCase():''}catch(e){return''}}
  function categoryKeysForHandle(h){var map={
    'electric-kettles':['Electric Kettle','Stovetop Gooseneck kettle','Glass kettle','Stainless steel kettle','Ceramic kettle','Gooseneck Kettle'],
    'coffee-makers':['Coffee Maker','Drip Coffee Maker','Espresso Machine','Milk Frother','Coffee Grinder'],
    'cooking-machines':['Cooking Machine','Steam Oven','Oven','Air fryer oven','Air Fryer','Airfyer oven'],
    'air-fryers':['Air Fryer','Air fryer oven','AirFryer Oven'],
    'espresso-machines':['Espresso Machine'],
    'other-products':['Other']
  };return map[h]||[]}
  function pickImage(prod,map){var o=(prod||{});if(o.primary_image&&String(o.primary_image).length>3){return o.primary_image}var m=map&&map[String(o.model||'').toUpperCase()];if(m&&m.length){return m[0]}return (window.HQP_PLACEHOLDER_URL||b+'images-01-index-factory-001.jpg')}
  function localCandidate(model){try{var M=String(model||'').toUpperCase().replace(/-/g,'');var bases=[M];var exts=['.png','.jpg','.jpeg','.webp'];if((window.HQP_ASSET_URL||'').indexOf('assets/')===0){for(var i=0;i<bases.length;i++){for(var j=0;j<exts.length;j++){var cand='assets/images/03-product/'+bases[i]+'/pic1'+exts[j];return cand}}}return null}catch(e){return null}}
  function el(tag,cls){var e=document.createElement(tag);if(cls)e.className=cls;return e}
  function runCategory(){var h=normHandle();var keys=categoryKeysForHandle(h);if(!keys.length)return;var grid=document.getElementById('category-product-grid')||document.getElementById('category-grid');if(!grid){var main=document.querySelector('main')||document.body;grid=el('div','grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8');grid.id='category-product-grid';main.appendChild(grid)}getData(function(data){ if(HQP.Utils.isDebugEnabled()) console.log('[HQP] runProductCatalog data received:', data ? (data.products ? data.products.length : 'no products') : 'no data');var products=Array.isArray(data&&data.products)?data.products:[];fetchJson([b+'js-image_product_map_files.json', 'assets/js-image_product_map_files.json', '/pages/assets/js-image_product_map_files.json', b+'image_product_map_files.json', 'assets/image_product_map_files.json', '/pages/assets/image_product_map_files.json', b+'js-image_product_map.json', 'assets/image_product_map.json', '/pages/assets/image_product_map.json'],function(mapData){var map=mapData||{};var inCat=function(p){var c=(p.category||'').trim();var sc=(p.subcategory||p.sub_category||'').trim();return keys.indexOf(c)>=0||keys.indexOf(sc)>=0};var list=products.filter(inCat);grid.innerHTML='';list.forEach(function(p){var card=el('div','bg-white rounded-2xl shadow-lg overflow-hidden product-card');var a=el('a','block relative aspect-[4/3]');a.href='/pages/product-detail?model='+(encodeModel(p.model||p.Model||''));var img=el('img','w-full h-full object-cover');try{img.setAttribute('loading','lazy');img.setAttribute('decoding','async')}catch(e){};var mappedEntry=mapPick(map,p.model||p.Model||'');var tryFiles=Array.isArray(mappedEntry)?mappedEntry[0]:null;var local=localCandidate(p.model||p.Model||'');img.src = HQP.Utils.normalizeImagePath(local || tryFiles || pickImage(p, map));img.alt=p.title||p.name||p.model||'Product';img.onerror = function(){ if(tryFiles){ img.src = HQP.Utils.normalizeImagePath(tryFiles); } else { img.src = HQP.Utils.normalizeImagePath(pickImage(p, map)); } };a.appendChild(img);card.appendChild(a);var body=el('div','p-6');var h3=el('h3','text-xl font-semibold text-gray-900 mb-2');h3.textContent=p.title||p.name||p.model||'Product';body.appendChild(h3);var model=el('p','text-gray-600 text-sm mb-4');model.textContent='Model: '+(p.model||'');body.appendChild(model);var ul=el('ul','list-disc list-inside text-sm text-gray-500 space-y-1 mb-4');(p.features||[]).slice(0,4).forEach(function(f){var li=el('li','');li.textContent=f;ul.appendChild(li)});body.appendChild(ul);var link=el('a','text-orange-400 hover:text-blue-600 font-medium text-sm');link.href=a.href;link.textContent='View Details →';body.appendChild(link);card.appendChild(body);grid.appendChild(card)})})})}
  function normalizeProductImage(img) { return HQP.Utils.normalizeImagePath(img); }

function loadImageMaps(cb){var m={};function g(x){if(!x)return;Object.keys(x).forEach(function(k){var v=x[k];m[k]=Array.isArray(v)?v:(v?[v]:[])});}fetchJson([b+'js-image_product_map_files.json','assets/js-image_product_map_files.json','/pages/assets/js-image_product_map_files.json'],function(a){g(a||{});fetchJson([b+'image_product_map_files.json','assets/image_product_map_files.json','/pages/assets/image_product_map_files.json'],function(c){g(c||{});cb(HQP.Utils.normalizeMap(m))})})}

function runFeaturedProducts() {
    var grid = document.getElementById('featured-products-grid');
    if(!grid) return;
    var mapFilesCache = window.__hqp_map_files || null;
    function loadMap(cb){
      if(mapFilesCache){ cb(mapFilesCache); return }
      fetchJson([b+'js-image_product_map_files.json',b+'js-image_product_map_files.json','assets/image_product_map_files.json','/pages/assets/image_product_map_files.json','assets/js-image_product_map_files.json','/pages/assets/js-image_product_map_files.json'], function(m){ mapFilesCache = m||{}; window.__hqp_map_files = mapFilesCache; cb(mapFilesCache) });
    }

    // Load featured list first
    fetchJson([b+'js-featured_products.json','assets/featured_products.json','/pages/assets/featured_products.json'], function(featData){
      var featuredList = Array.isArray(featData) ? featData : (featData && featData.featured ? featData.featured : []);
      loadMap(function(mapFiles){
        // Load full DB
        getData(function(dbData){
          var productsDB = Array.isArray(dbData) ? dbData : (dbData && dbData.products ? dbData.products : []);
          
          var itemsToShow = featuredList.slice(0, 4).map(function(item){
            var model = (typeof item === 'string') ? item : (item.model || item.Model || '');
            var title = (typeof item === 'object') ? (item.title || item.ProductName || model) : model;
            var img = (typeof item === 'object') ? (item.image || item.Pic1) : null;

            // Find in DB
            var dbItem = productsDB.find(function(p){
                return String(p.model || p.Model).toUpperCase() === String(model).toUpperCase();
            });
            
            if(dbItem) {
              title = dbItem.ProductName || dbItem.title || title;
              if(!img && dbItem.images && dbItem.images.length > 0) img = dbItem.images[0];
              if(!img) img = dbItem.Pic1;
            }

            var mappedEntry = mapPick(mapFiles, model);
            var mapped = Array.isArray(mappedEntry) ? mappedEntry[0] : null;
            var finalImg = mapped ? HQP.Utils.normalizeImagePath(mapped) : normalizeProductImage(img);
            
            return { 
                model: model, 
                title: title, 
                img: finalImg, 
                link: '/pages/product-detail?model=' + encodeModel(model) 
            };
          });

          if(itemsToShow.length === 0) {
            grid.innerHTML = '<div class="col-span-full text-center py-8 text-gray-500">No featured products found.</div>';
            return;
          }

          grid.innerHTML = itemsToShow.map(function(p){
            return '<a href="'+p.link+'" class="block border rounded-lg overflow-hidden hover:shadow-md transition">' +
              '<div class="aspect-square bg-white overflow-hidden">' +
                '<img src="'+p.img+'" alt="'+p.title+'" class="w-full h-full object-cover" loading="lazy" decoding="async" onerror="this.src=\''+(window.HQP_PLACEHOLDER_URL||'assets/images/placeholder.svg')+'\'">' +
              '</div>' +
              '<div class="p-3 text-sm">' +
                '<div class="font-bold">'+p.model+'</div>' +
                '<div class="text-gray-600 truncate"></div>' +
              '</div>' +
            '</a>';
          }).join('');
          try{initLazyImages()}catch(e){}
        });
      });
    });
  }
  window.runFeaturedProducts = runFeaturedProducts;

  function runProductCarousel() { if(HQP.Utils.isDebugEnabled()) console.log('[HQP] runProductCarousel start');
      var track = document.getElementById('carousel-track');
      var indicators = document.getElementById('carousel-indicators');
      if (!track) return;

      var carouselData = [];
      var currentIndex = 1;
      var autoPlayInterval;
      var isTransitioning = false;

      function initCarousel() {
          if (carouselData.length === 0) return;
          var posMap = { 3: 35, 4: 80, 6: 60, 7: 70, 8: 70, 9: 40, 12: 30, 14: 70, 17: 70 };
          var firstClone = carouselData[0];
          var lastClone = carouselData[carouselData.length - 1];
          var allItems = [lastClone].concat(carouselData, [firstClone]);
          
          track.innerHTML = allItems.map(function(item, index) {
              var realIndex;
              if (index === 0) realIndex = carouselData.length - 1;
              else if (index === allItems.length - 1) realIndex = 0;
              else realIndex = index - 1;
              var posY = posMap[realIndex] !== undefined ? posMap[realIndex] : 50;
          return '<div class="w-full flex-shrink-0 h-full relative group">' +
                  '<a href="'+item.link+'" class="block w-full h-full">' +
                      '<img src="'+item.src+'" alt="'+item.title+'" class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" decoding="async" style="object-position: center '+posY+'%" onerror="this.src=\''+(window.HQP_PLACEHOLDER_URL||'assets/images/placeholder.svg')+'\'">' +
                      '<div class="hqp-carousel-caption absolute bottom-0 left-0 right-0 p-8 text-white transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300" style="text-shadow: 2px 2px 4px rgba(0,0,0,0.8);">' +
                          '<h3 class="text-3xl font-bold mb-2">'+item.model+'</h3>' +
                          '<p class="text-lg opacity-90">'+item.title+'</p>' +
                      '</div>' +
                  '</a>' +
              '</div>';
          }).join('');

          if(indicators) {
              indicators.innerHTML = carouselData.map(function(_, i) {
                  return '<button class="w-3 h-3 rounded-full bg-white/50 hover:bg-white transition-all '+(i === 0 ? 'bg-white scale-125' : '')+'" data-index="'+(i+1)+'"></button>';
              }).join('');
              Array.prototype.forEach.call(indicators.children, function(btn){
                  on(btn, 'click', function(){ jumpTo(parseInt(this.getAttribute('data-index'))) });
              });
          }

          track.style.transform = 'translateX(-100%)';
          startAutoPlay();
          
          // Attach arrow events
          var prevBtn = track.parentNode.querySelector('.fa-chevron-left');
          var nextBtn = track.parentNode.querySelector('.fa-chevron-right');
          if(prevBtn) on(prevBtn.parentNode, 'click', function(){ moveCarousel(-1) });
          if(nextBtn) on(nextBtn.parentNode, 'click', function(){ moveCarousel(1) });
      }

      function updateCarousel() {
          track.style.transition = 'transform 0.5s ease-in-out';
          track.style.transform = 'translateX(-'+(currentIndex * 100)+'%)';
          
          if(indicators) {
              var realIndex = currentIndex - 1;
              if (currentIndex === 0) realIndex = carouselData.length - 1;
              if (currentIndex === carouselData.length + 1) realIndex = 0;
              
              Array.prototype.forEach.call(indicators.children, function(btn, i){
                  if (i === realIndex) {
                      btn.classList.add('bg-white', 'scale-125');
                      btn.classList.remove('bg-white/50');
                  } else {
                      btn.classList.remove('bg-white', 'scale-125');
                      btn.classList.add('bg-white/50');
                  }
              });
          }
      }

      function moveCarousel(direction) {
          if (isTransitioning) return;
          isTransitioning = true;
          currentIndex += direction;
          updateCarousel();
          
          var onTransitionEnd = function() {
              isTransitioning = false;
              if (currentIndex === 0) {
                  track.style.transition = 'none';
                  currentIndex = carouselData.length;
                  track.style.transform = 'translateX(-'+(currentIndex * 100)+'%)';
              } else if (currentIndex === carouselData.length + 1) {
                  track.style.transition = 'none';
                  currentIndex = 1;
                  track.style.transform = 'translateX(-100%)';
              }
              track.removeEventListener('transitionend', onTransitionEnd);
          };
          track.addEventListener('transitionend', onTransitionEnd);
          resetAutoPlay();
      }

      // Expose minimal controls for inline handlers in templates
      try { window.moveCarousel = moveCarousel; } catch(e) {}
      try { window.jumpToCarousel = jumpTo; } catch(e) {}

      function jumpTo(index) {
          if (isTransitioning) return;
          currentIndex = index;
          updateCarousel();
          resetAutoPlay();
      }

      function startAutoPlay() {
          stopAutoPlay();
          autoPlayInterval = setInterval(function(){ moveCarousel(1) }, 5000);
      }

      function stopAutoPlay() {
          if(autoPlayInterval) clearInterval(autoPlayInterval);
      }

      function resetAutoPlay() {
          stopAutoPlay();
          startAutoPlay();
      }

      // Load data
      fetchJson([b+'js-featured_products.json', 'assets/featured_products.json'], function(featData){
          var products = Array.isArray(featData) ? featData : (featData && featData.featured ? featData.featured : []);
          
          // Load DB for images
          getData(function(dbData){
               var byModel = {};
               if(dbData && Array.isArray(dbData.products)) {
                   dbData.products.forEach(function(p2){
                       var mk = String((p2.model || p2.Model || '')).toUpperCase();
                       var imgs = Array.isArray(p2.images) ? p2.images : [];
                       byModel[mk] = imgs.map(normalizeProductImage);
                   });
               }
               
               carouselData = products.map(function(p){
                   var mkey = String(p.model || p.Model || '').toUpperCase();
                   var primary = (p.images && Array.isArray(p.images) && p.images.length > 0) ? p.images[0] : (p.Pic1 || null);
                   var fromDb = (byModel[mkey] && byModel[mkey][0]) || null;
                   var src = fromDb || normalizeProductImage(primary);
                   return {
                       src: src,
                       title: p.title || p.ProductName || p.model || p.Model,
                       model: p.model || p.Model,
                       link: '/pages/product-detail?model=' + encodeModel(p.model || p.Model)
                   };
      });
          if(carouselData.length===0){ var selected=(dbData && dbData.products ? dbData.products : []).slice(0,18); carouselData = selected.map(function(p){   var primary=(p.images && Array.isArray(p.images) && p.images.length>0) ? p.images[0] : (p.Pic1 || null);   var src=HQP.Utils.normalizeImagePath(primary);   return { src: src, title: (p.title||p.ProductName||p.model||p.Model), model: (p.model||p.Model), link: '/pages/product-detail?model=' + (p.model||p.Model) }; }); } initCarousel(); updateCarousel();});
      });
  }
  window.runProductCarousel = runProductCarousel;

  document.addEventListener('DOMContentLoaded', function(){
      if(document.getElementById('product-carousel-container')) runProductCarousel();
      if(document.getElementById('featured-products-grid')) runFeaturedProducts();
      if(document.getElementById('full-product-grid')) runProductCatalog();
      if(document.getElementById('product-detail-container')) runProductDetail();
      // runProducts() is for stats on About page or Home page if elements exist
      if(document.getElementById('kettle-count') || document.getElementById('total-products-info')) runProducts();
  });

  function runProductCatalog(){
     var grid = document.getElementById('full-product-grid');
     if(!grid) return;
     
     var searchInput = document.getElementById('product-search');
    var catSelect = document.getElementById('category-filter');
    
    var allProducts = [];
    
    function render(list){
      if(!list || list.length === 0){
        grid.innerHTML = '<div class="col-span-full text-center py-12 text-gray-500">No products found matching your criteria.</div>';
        return;
      }
      grid.innerHTML = list.map(function(p){
        var model = p.model || p.Model || '';
        var title = p.title || p.ProductName || model;
        var img = (p.images && p.images.length > 0) ? p.images[0] : (p.Pic1 || (window.HQP_PLACEHOLDER_URL||'assets/images/placeholder.svg'));
        
        // Normalize image path
        img = normalizeProductImage(img);
        
        // Extract Color from Description
        var desc = p.Description || p.description || '';
        var colorMatch = desc.match(/Color:\s*([^\n\r]+)/i);
        var colorInfo = colorMatch ? colorMatch[1].trim() : '';
        var colorHtml = '';
        
        if (colorInfo) {
            // Try to generate color dots
            var colors = colorInfo.split(/[,/]/).map(function(c){ return c.trim() });
            var dots = colors.map(function(c){
                var map = {
                    'white': '#ffffff', 'black': '#000000', 'grey': '#808080', 'gray': '#808080',
                    'red': '#ef4444', 'blue': '#3b82f6', 'green': '#10b981', 'pink': '#ec4899',
                    'silver': '#c0c0c0', 'stainless steel': '#d1d5db', 'cream': '#fef3c7',
                    'orange': '#f97316', 'yellow': '#eab308', 'purple': '#a855f7',
                    'brown': '#78350f', 'darkgreen': '#064e3b', 'lightgray': '#d1d5db'
                };
                var bg = map[c.toLowerCase()] || '#e5e7eb';
                var border = c.toLowerCase() === 'white' ? 'border-gray-300' : 'border-transparent';
                return '<span class="inline-block w-3 h-3 rounded-full border '+border+' mr-1" style="background-color:'+bg+'" title="'+c+'"></span>';
            }).join('');
            
            colorHtml = '<div class="flex items-center mb-2" title="Colors: '+colorInfo+'">' + 
                        '<span class="text-xs text-gray-500 mr-2">Colors:</span>' + 
                        '<div class="flex flex-wrap">' + dots + '</div>' +
                        '</div>';
        } else {
             // Placeholder to keep alignment if needed, or just empty
             colorHtml = '<div class="h-6 mb-2"></div>'; 
        }

        return '<a href="/pages/product-detail?model='+encodeModel(model)+'" class="block product-card rounded-xl shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden border border-gray-100 group">' +
            '<div class="aspect-w-1 aspect-h-1 bg-transparent relative">' +
              '<img src="'+img+'" alt="'+title+'" class="w-full h-64 object-contain p-4 transform group-hover:scale-105 transition-transform duration-500" loading="lazy" decoding="async" onerror="this.src=(window.HQP_PLACEHOLDER_URL||\'assets/images/placeholder.svg\')">' +
            '</div>' +
          '<div class="p-4 product-info-bg">' +
             '<p class="text-xs text-gray-500 mb-1 font-medium uppercase tracking-wide">'+(p.category||p.Category||'Product')+'</p>' +
             '<h3 class="text-lg font-bold text-gray-900 mb-1 truncate group-hover:text-blue-600 transition-colors">'+model+'</h3>' +
            '<p class="text-sm text-gray-600 line-clamp-2 h-10 mb-2">'+title+'</p>' +
            colorHtml +
            '<div class="flex items-center text-orange-400 group-hover:text-blue-600 font-bold text-xs uppercase tracking-wider group-hover:translate-x-1 transition-transform">View Details <i class="fa fa-arrow-right ml-1"></i></div>' +
          '</div>' +
        '</a>';
      }).join('');
    }
    
    function filter(){
       var q = (searchInput ? searchInput.value : '').toLowerCase();
       var c = (catSelect ? catSelect.value : '');
       
       var filtered = allProducts.filter(function(p){
         var m = String(p.model || p.Model || '').toLowerCase();
         var t = String(p.title || p.ProductName || '').toLowerCase();
         var cat = String(p.category || '').toLowerCase();
         
         var matchSearch = m.indexOf(q) !== -1 || t.indexOf(q) !== -1;
         var matchCat = true;
         
         if(c){
             if(c === 'electric_kettle') matchCat = cat.includes('kettle') || cat.includes('water');
             else if(c === 'coffee_maker') matchCat = cat.includes('coffee') || cat.includes('espresso');
             else if(c === 'cooking_machine') matchCat = cat.includes('cooking') || cat.includes('blender') || cat.includes('chopper');
             else if(c === 'air_fryer') matchCat = cat.includes('air') || cat.includes('fryer');
             else matchCat = cat.includes(c) || String(p.subcategory||'').toLowerCase().includes(c);
         }
         
         return matchSearch && matchCat;
       });
       render(filtered);
     }
    
    getData(function(data){ if(HQP.Utils.isDebugEnabled()) console.log('[HQP] runProductCatalog data received:', data ? (data.products ? data.products.length : 'no products') : 'no data');
       try {
         allProducts = Array.isArray(data) ? data : (data && data.products ? data.products : []);
         
         // Initial render
         var urlCat = qs('category');
         if(urlCat && catSelect){
             catSelect.value = urlCat;
         }
         
         filter();
         
         if(searchInput) on(searchInput, 'input', filter);
         if(catSelect) on(catSelect, 'change', filter);
       } catch(e) {
         console.error('runProductCatalog callback error:', e);
       }
     });
  }
  window.runProductCatalog = runProductCatalog;
  function hqp_qs(k){try{var p=new URLSearchParams(location.search||'');return p.get(k)||''}catch(e){return''}}
  function hqp_cur_style(){try{var v=String(hqp_qs('style')||'').toLowerCase();if(v)return v;v=String(localStorage.getItem('hqp_style')||'').toLowerCase();if(!v)v='style5';if(!['style1','style2','style3','style4','style5','style6'].includes(v))v='style5';return v}catch(e){return'style5'}}
  function hqp_apply_style(s){
    try{localStorage.setItem('hqp_style',s||'')}catch(e){};
    if(window.HQP&&HQP.UI&&typeof HQP.UI.applyStyleVariant==='function'){try{HQP.UI.applyStyleVariant()}catch(e){}return}
    try{
        var baseLink=
            document.querySelector('link[href*="common-hqp.css"]') ||
            document.querySelector('link[href*="common-hqp-style5.css"]') ||
            document.querySelector('link[href*="css-common-hqp-style5.css"]') ||
            document.querySelector('link[href*="common-hqp-style1.css"]') ||
            document.querySelector('link[href*="css-common-hqp-style1.css"]') ||
            document.querySelector('link[href*="css-common-hqp.css"]');
        if(!baseLink) return; // Should not happen if common-hqp.css is present

        // Calculate base path from the existing link
        var href = baseLink.getAttribute('href');
        var base = href.substring(0, href.lastIndexOf('/') + 1);
        
        // Ensure data-style is set for CSS scoping
        var finalStyle = s || 'style5';
        document.documentElement.setAttribute('data-style', finalStyle);

        var overrideId = 'hqp-theme-override';
        var overrideLink = document.getElementById(overrideId);

        // Always apply the specific style sheet, even for style1
        var targetCss = 'common-hqp-' + finalStyle + '.css';
        // Handle hashed assets if map exists
        if(window.HQP && HQP.AssetMap) {
            var mapKey = 'assets/css/' + targetCss;
            if(HQP.AssetMap[mapKey]) {
                targetCss = HQP.AssetMap[mapKey].split('/').pop();
            }
        }

        if(!overrideLink) {
            overrideLink = document.createElement('link');
            overrideLink.id = overrideId;
            overrideLink.rel = 'stylesheet';
            // Insert after baseLink to ensure override
            baseLink.parentNode.insertBefore(overrideLink, baseLink.nextSibling);
        }
        overrideLink.href = base + targetCss + '?t=' + new Date().getTime(); // Add timestamp to force reload
        
        // Remove old specific dark logic if present
        var dk=document.querySelector('link[href*="common-hqp-dark.css"]');
        if(dk && dk.parentNode && dk.id !== overrideId) dk.parentNode.removeChild(dk);
        
    }catch(e){ console.error(e) }
  }
  function hqp_init_style_menu(){
    var nav=document.querySelector('.sticky-nav')||document.querySelector('nav');
    if(!nav) return;
    if(document.getElementById('hqp-style-button')||document.getElementById('hqp-style-menu')) return;

    try{ if(nav.style) nav.style.position='relative'; }catch(e){}

    var wrap=document.createElement('div');
    wrap.id='hqp-style-wrap';
    wrap.style.position='absolute';
    wrap.style.right='16px';
    wrap.style.top='50%';
    wrap.style.transform='translateY(-50%)';
    wrap.style.zIndex='9999';
    wrap.style.display='inline-flex';
    wrap.style.alignItems='center';
    wrap.style.marginLeft='0';
    wrap.style.flexShrink='0';

    var btn=document.createElement('button');
    btn.id='hqp-style-button';
    btn.type='button';
    btn.style.display='inline-flex';
    btn.style.alignItems='center';
    btn.style.justifyContent='center';
    btn.style.padding='2px';
    btn.style.margin='0';
    btn.style.borderRadius='6px';
    btn.style.background='transparent';
    btn.style.cursor='pointer';
    btn.style.opacity='0.85';
    btn.onmouseenter=function(){btn.style.opacity='1'};
    btn.onmouseleave=function(){btn.style.opacity='0.85'};
    btn.innerHTML=''+
      '<span style="display:grid;grid-template-columns:repeat(2,6px);gap:2px;align-items:center;justify-items:center;padding:2px">'+
        '<span style="width:6px;height:6px;border-radius:50%;background:#ef4444;display:inline-block"></span>'+
        '<span style="width:6px;height:6px;border-radius:50%;background:#f59e0b;display:inline-block"></span>'+
        '<span style="width:6px;height:6px;border-radius:50%;background:#10b981;display:inline-block"></span>'+
        '<span style="width:6px;height:6px;border-radius:50%;background:#3b82f6;display:inline-block"></span>'+
      '</span>';
    wrap.appendChild(btn);

    var styleNames={'style1':'Classic Yellow','style2':'Midnight Black','style3':'Elegant Red','style4':'Nature Green','style5':'Deep Teal Green','style6':'Minimalist Gray'};
    var menu=document.createElement('div');
    menu.id='hqp-style-menu';
    menu.className='hidden';
    menu.style.position='absolute';
    menu.style.right='0';
    menu.style.top='calc(100% + 10px)';
    menu.style.border='1px solid rgba(229,231,235,1)';
    menu.style.borderRadius='8px';
    menu.style.boxShadow='0 10px 20px rgba(0,0,0,0.15)';
    menu.style.backgroundColor='rgba(255,255,255,0.92)';
    menu.style.backdropFilter='blur(6px)';
    menu.style.padding='4px 0';
    menu.style.zIndex='9999';
    menu.innerHTML=['style1','style2','style3','style4','style5','style6'].map(function(k){return '<button type="button" data-style="'+k+'" class="flex items-center w-48 px-3 py-2 text-sm hover:bg-gray-100" style="color:#111827; text-align:left;"><span class="hqp-dot inline-block w-2 h-2 rounded-full mr-2 flex-shrink-0"></span><span>'+(styleNames[k]||k)+'</span></button>'}).join('');
    wrap.appendChild(menu);

    try{nav.appendChild(wrap)}catch(e){}

    function syncVis(){
      try{
        var isMobile=false;
        if(window.matchMedia){
          isMobile=window.matchMedia('(max-width: 767.98px)').matches;
        }else{
          isMobile=(window.innerWidth||0)<768;
        }

        var mobileBtn = nav.querySelector('.mobile-menu-button');
        var mobileHost = mobileBtn && mobileBtn.parentNode;

        if(isMobile && mobileHost){
          if(wrap.parentNode !== mobileHost){
            if(mobileBtn.nextSibling){
              mobileHost.insertBefore(wrap, mobileBtn.nextSibling);
            }else{
              mobileHost.appendChild(wrap);
            }
          }
          wrap.style.position='static';
          wrap.style.right='auto';
          wrap.style.top='auto';
          wrap.style.transform='none';
          wrap.style.marginLeft='10px';
          wrap.style.marginRight='0';
          wrap.style.zIndex='9999';
          wrap.style.display='inline-flex';
          btn.style.padding='6px';
        } else {
          if(wrap.parentNode !== nav){
            nav.appendChild(wrap);
          }
          wrap.style.position='absolute';
          wrap.style.right='16px';
          wrap.style.top='50%';
          wrap.style.transform='translateY(-50%)';
          wrap.style.marginLeft='0';
          wrap.style.marginRight='0';
          wrap.style.zIndex='9999';
          wrap.style.display='inline-flex';
          btn.style.padding='2px';
        }
      }catch(e){}
    }
    try{syncVis();window.addEventListener('resize',syncVis)}catch(e){}

    btn.addEventListener('click',function(e){try{e.preventDefault();e.stopPropagation()}catch(_e){};menu.classList.toggle('hidden')});
    function setDot(){var cur=hqp_cur_style();Array.prototype.forEach.call(menu.querySelectorAll('button'),function(b){var d=b.querySelector('.hqp-dot');if(!d)return;d.style.display='inline-block';d.className='hqp-dot inline-block w-2 h-2 rounded-full mr-2 flex-shrink-0';if(b.getAttribute('data-style')===cur){d.classList.add('bg-blue-600');d.classList.remove('bg-gray-300')}else{d.classList.remove('bg-blue-600');d.classList.add('bg-gray-300')}})}
    setDot();
    menu.addEventListener('click',function(e){var t=e.target.closest('button[data-style]');if(!t)return;var k=t.getAttribute('data-style');hqp_apply_style(k);setDot();menu.classList.add('hidden')});
    document.addEventListener('click',function(e){var inside=e.target.closest('#hqp-style-wrap');if(!inside)menu.classList.add('hidden')});
  }
  try{hqp_init_style_menu()}catch(e){}
  document.addEventListener('DOMContentLoaded',function(){ var __h=(function(){try{var p=location.pathname||'';var m=p.match(/\/pages\/([^\/?#]+)/i);return m?m[1].toLowerCase():''}catch(e){return''}})(); if(['electric-kettles','coffee-makers','cooking-machines','air-fryers','espresso-machines','other-products'].indexOf(__h)>=0 && !document.getElementById('category-product-grid')) runCategory(); try{hqp_init_style_menu()}catch(e){}})
  function openCertModal(src,pdfSrc){var modal=document.getElementById('cert-modal');var imgContainer=document.getElementById('modal-image-container');var pdfContainer=document.getElementById('modal-pdf-container');var img=document.getElementById('modal-cert-image');var pdfFrame=document.getElementById('modal-cert-pdf');var actionContainer=document.getElementById('modal-action-container');actionContainer.innerHTML='';imgContainer.classList.add('hidden');pdfContainer.classList.add('hidden');if(modal){modal.classList.remove('hidden');modal.classList.add('flex');document.body.style.overflow='hidden';if(pdfSrc){pdfContainer.classList.remove('hidden');var ld=document.getElementById('pdf-loading');if(ld)ld.classList.remove('hidden');pdfFrame.src=pdfSrc+'#toolbar=0&navpanes=0';document.addEventListener('keydown',blockPrint,true)}else{imgContainer.classList.remove('hidden');img.src=src}}}
  function closeCertModal(){var modal=document.getElementById('cert-modal');var pdfFrame=document.getElementById('modal-cert-pdf');if(modal){modal.classList.add('hidden');modal.classList.remove('flex');document.body.style.overflow='';if(pdfFrame)pdfFrame.src='';document.removeEventListener('keydown',blockPrint,true)}}
  function blockPrint(e){var k=e.key?e.key.toLowerCase():'';if((e.ctrlKey||e.metaKey)&&(k==='p'||k==='s')){e.preventDefault();e.stopPropagation()}}
  try{window.openCertModal=openCertModal;window.closeCertModal=closeCertModal;window.blockPrint=blockPrint}catch(e){}
})();
